import styled from "styled-components";

export const OptInWinHighlightDefaultBox = styled.div`
    display: flex;  
    flex-direction: column;
    justify-content: space-evenly;

    width: 127px;
    height: 48px;
    padding: 4px 12px;

    border-radius: 90px;
    border: 2px solid #7FF800;

    background-color: #22004d; 
    background-image: radial-gradient( #9747ff 2%, #22004d 40%);
    margin: 0px 6px;

`